import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeExamToken, getExamToken } from '../auth/examToken';

/**
 * Exam token for this tab (delivered via URL fragment, kept in sessionStorage; see auth/examToken.js)
 * and its decoded payload (supports legacy base64 JSON and signed "payload.signature").
 * Returns { token, decoded, userId, userName, registrationId, role, ... }.
 */
export function useToken() {
  const { pathname } = useLocation();
  return useMemo(() => {
    const token = getExamToken();
    const decoded = decodeExamToken(token);
    return {
      token,
      decoded,
      userId: decoded?.user_id ?? decoded?.userId ?? 'guest',
      userName: decoded?.user_name ?? decoded?.userName ?? 'Student',
      student_user_id: decoded?.student_user_id ?? decoded?.student_user_id ?? '',
      registrationId: decoded?.registration_id ?? decoded?.registrationId ?? null,
      role: decoded?.role ?? 'student',
      course: decoded?.course ?? '',
      exam_date: decoded?.exam_date,
      exam_time: decoded?.exam_time,
      fullName: decoded?.full_name ?? '',
      assessment_id: decoded?.assessment_id ?? null,
      register_number: decoded?.register_number ?? decoded?.register_no ?? null,
      room_id: decoded?.room_id ?? decoded?.room_id ?? null,
    };
  }, [pathname]);
}
